import { deconstruct, none, some } from "widgets-for-react";
import { isLeft, isRight, mapRight } from "./sum";
export const isSome = (o)=>isRight(o);
export const isNone = (o)=>isLeft(o);
export const mapOption = (f)=>mapRight(f);
/**
 * Returns the value of an Option if some, otherwise it will return the default value provided by the lazy function.
 * @param lazyDefault Lazy function that produces the default value
 * @param o The option containing the desired value
 * @returns The value of the option if some, otherwise the default value provided by the lazy function
 */ export const valueOrDefault = (lazyDefault, o)=>deconstruct(lazyDefault, (v)=>v, o);
export const valueOrExcept = function(o) {
    let message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Option was `None` where `Some<X>` was expected";
    return valueOrDefault(()=>{
        throw new UnexpectedNoneException(message);
    }, o);
};
export const fromNullable = (x)=>x !== undefined && x !== null ? some(x) : none();
export const toNullable = (o)=>valueOrDefault(()=>undefined, o);
export const tryOrNone = (f)=>(x)=>{
        try {
            return some(f(x));
        } catch (e) {
            return none();
        }
    };
export const tryOrNull = (f)=>(x)=>toNullable(tryOrNone(f)(x));
class UnexpectedNoneException extends Error {
    constructor(message){
        super(message);
    }
}
